<template>
    <div>
        <v-app-bar app color="header">
            <!-- Left-aligned text with icon -->
            <v-toolbar-items>
                <v-chip v-if="meeting.isRecording() && meeting.local_peer && !['record', 'record-guest'].includes(meeting.local_peer.roleName)" color="black" text-color="white" class="ma-4">
                    <v-icon left color="red">mdi-record</v-icon>
                    Recording
                </v-chip>
            </v-toolbar-items>

            <!-- Spacer to push elements to opposite ends -->
            <v-spacer></v-spacer>

            <!-- Logo Image -->
            <v-img v-if="app.room && app.room.settings && !['', null, 'test'].includes(app.room.settings.header_logo)" :src="app.room.settings.header_logo" max-height="40" contain position="center" />
            <v-img v-else-if="app.site && app.site.domain_settings && app.site.domain_settings.settings.header_logo && !['', null, 'test'].includes(app.site.domain_settings.settings.header_logo)" :src="app.site.domain_settings.settings.header_logo" max-height="40" contain position="center" />
            <div v-else-if="app.room" class="text-h5 font-weight-bold primary--text" style="text-align:center;width:100%;">{{app.room.post_title}}</div>
            <div v-else class="text-h5 font-weight-bold primary--text" style="text-align:center;width:100%;">VIPHuddles.com</div>

            <!-- Another Spacer for symmetry -->
            <v-spacer></v-spacer>

            <!-- Additional toolbar items or components here, if needed -->
        </v-app-bar>

        


        <!-- BM: LOGIN DIALOG -->
        <v-dialog
            v-model="this.show_login_dialog"
            width="500"
            persistent
            overlay-opacity="1"
            >
            <v-card>
                <v-card-title class="text-h5 primary">
                    <v-icon class="mr-2">mdi-lock</v-icon>
                    Account Login
                </v-card-title>

                <v-card-text class="px-6 pt-6 pb-0">
                    <v-alert v-model="app.show_login_error" color="error" text icon="mdi-alert-circle">Login failed</v-alert>
                    <p>Please log in:</p>
                    <v-text-field label="Email" outlined v-model="login.email"></v-text-field>
                    <v-text-field label="Password" type="password" outlined v-model="login.password"></v-text-field>
                </v-card-text>

                <v-card-actions class="px-6 pb-6 pt-0 mt-0">
                    <v-btn text color="grey" x-small>Forgot Password</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        @click="app.doLogin(login.email, login.password)"
                        :loading="app.is_logging_in"
                        :disabled="app.is_logging_in"
                    >
                        Login
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-overlay :value="app.show_app_overlay" opacity="1">
            <v-progress-circular
                indeterminate
                size="64"
            ></v-progress-circular>
            <div>{{app.app_overlay_text}}</div>
        </v-overlay>

        <!-- BM: SNACKBAR ALERTS -->
        <v-snackbar 
            :centered="!!app.snackbar.settings.centered" 
            :color="app.snackbar.settings.color" 
            v-model="app.snackbar.settings.show" 
            :top="!!app.snackbar.settings.top" 
            :timeout="app.snackbar.timeout"
        >
            {{app.snackbar.settings.message}}
            <template v-slot:action="{ attrs }">
                <v-btn
                    icon
                    v-bind="attrs"
                    @click="app.snackbar.settings.show = false"
                >
                    <v-icon>mdi-close-circle</v-icon>
                </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>
import { useUserStore } from "../stores/user"
import { usePhoneNumbersStore } from "../stores/phone_numbers"
import { useAppStore } from "../stores/app"
import { useMeetingStore } from "../stores/meeting"
// import axios from 'axios'

export default {
	name: 'SystemBar',
    created() {
        this.user = useUserStore()
        this.phone_numbers = usePhoneNumbersStore()
        this.app = useAppStore()
        this.meeting = useMeetingStore()

        this.app.getSiteSettings(this.$vuetify)
		this.user.fetchUser()
        // this.phone_numbers.fetchPhoneNumbers()
	},
    data: () => {
        return {
            user: null,
            phone_numbers: null,
            app: null,
            login: {
                email: "",
                password: ""
            },
            show_login_dialog: false,
            // is_logging_in: false,
            // show_login_error: false,
            // check_login_interval: null
        }
    },
    mounted: function() {
        // this.app.createInterval()
        // this.app.getUnreadMessages()
        // this.app.getTasks()
        // this.app.subscribe()
    },
    methods: {
        
    }
}

</script>

<style scoped>
.v-list-item {
	cursor: pointer;
}
.v-toolbar__content {
    justify-content: center !important;
}
</style>
